<template>
  <!-- 单次计价收费模板 -->
  <el-card
    style="width:815px"
  >
    <el-form
      ref="ruleTemp"
      label-width="120px"
    >
      <el-form-item label="单条计价列表：">
      </el-form-item>
      <ul class="valuation-field-ul clearfix">
        <li>计价字段</li>
        <li>计价值</li>
        <li>价格(元)</li>
      </ul>
      <div
        v-for="item in ruleData.outputParamsPricings"
        :key="item.key"
        class="clearfix"
      >
        <div class="valuation-field-wrap clearfix">
          <div
            class="valuation-field-list clearfix"
            style="width:60%;float:left"
          >
            <div
              v-for="(domain, index) in item.outputParamsPricing.pricing"
              :key="index"
              class="valuation-field-child clearfix"
              style="margin-bottom:10px"
            >
              <div
                :prop="'pricing.' + index +'.key'"
                style="width:120px;float:left;margin-left:10px"
              >
                <el-select
                  v-model="domain.key"
                  disabled
                  placeholder=""
                >
                  <el-option
                    v-for="param in interfaceParams"
                    :key="param.paramIdentify"
                    :label="param.paramName"
                    :value="param.paramIdentify"
                  ></el-option>
                </el-select>
              </div>
              <div
                :prop="'pricing.' + index +'.type'"
                style="width:120px;float:left;margin:0 15px 0 15px"
              >
                <el-select
                  v-model="domain.type"
                  disabled
                  placeholder=""
                >
                  <el-option
                    value="1"
                    label="等于"
                  ></el-option>
                  <el-option
                    value="2"
                    label="大于等于"
                  ></el-option>
                  <el-option
                    value="3"
                    label="小于等于"
                  ></el-option>
                  <el-option
                    value="4"
                    label="大于"
                  ></el-option>
                  <el-option
                    value="5"
                    label="小于"
                  ></el-option>
                  <el-option
                    value="6"
                    label="不等于"
                  ></el-option>
                </el-select>
              </div>
              <div
                :prop="'pricing.' + index +'.value'"
                style="width:120px;float:left"
              >
                <el-input
                  v-model="domain.value"
                  disabled
                  placeholder=""
                ></el-input>
              </div>
            </div>
          </div>
          <span
            class="valuation-field-btn"
            style="display:block;width:40%;float:left"
          >
            <el-input
              v-model="item.outputParamsPricing.price"
              disabled
              placeholder
              style="width:150px;float:right;margin-right:10px"
            ></el-input>
          </span>
        </div>
      </div>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['ruleData', 'dataDetail'],
  name: 'valuationTemplate1',
  data () {
    return {
      inputParams: [],
      interfaceParams: []
    }
  },
  created () {
    this.queryInterfaceParamInfoByAll()
    console.log(this.ruleData)
  },
  methods: {
    /* 查询计价字段列表 */
    queryInterfaceParamInfoByAll () {
      let _self = this
      /* 查询计价策略列表 */
      this.$axios
        .get(this.$API.valuation.queryInterfaceParamInfoByAll, {})
        .then(function (r) {
          let data = r.data.resData.paramNameList
          _self.interfaceParams = r.data.resData.paramNameList
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].paramType === '1') {
                _self.inputParams.push(data[i])
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /* 附加入参修改是否清空数据 */
    changeFlag (value) {
      this.ruleTemp.inputParamsPricing.pricingunit = []
    },
    /* 新增附加入参组 */
    addInputParams () {
      this.ruleTemp.inputParamsPricing.pricingunit.push({
        key: '',
        value: ''
      })
    },
    /* 删除附加入参组 */
    removeInputParams (item) {
      let _index = this.ruleTemp.inputParamsPricing.pricingunit.indexOf(item)
      if (_index !== -1) {
        this.ruleTemp.inputParamsPricing.pricingunit.splice(_index, 1)
      }
    },
    /* 新增计价规则一组 */
    addGroup () {
      this.ruleTemp.outputParamsPricings.push({
        outputParamsPricing: {
          pricing: [
            {
              type: '',
              key: '',
              value: ''
            }
          ],
          price: ''
        }
      })
    },
    /* 删除组 */
    removeGroup (item) {
      let index = this.ruleTemp.outputParamsPricings.indexOf(item)
      if (index !== -1) {
        this.ruleTemp.outputParamsPricings.splice(index, 1)
      }
    },
    /* 新增子字段 */
    addChild (item) {
      item.outputParamsPricing.pricing.push({
        type: '',
        key: '',
        value: ''
      })
    },
    /* 移除子字段 */
    removeChild (item, index) {
      if (index !== -1) {
        item.outputParamsPricing.pricing.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../assets/sass/base.scss";
.clearfix {
  @include clearfix;
}
.text-wrap {
  overflow: hidden;
  line-height: 30px;
  width: 100%;
}

.valuation-field-ul {
  li {
    float: left;
    width: 32%;
    text-align: center;
    line-height: 50px;
  }
}
.valuation-field-wrap {
  position: relative;
  margin-bottom: 20px;
  border-bottom: #ddd solid 1px;
  .valuation-field-list {
    .valuation-field-child {
      position: relative;
      height: 45px;
      &:before {
        content: "";
        position: absolute;
        top: 20px;
        right: -40px;
        width: 45px;
        height: 1px;
        background: #409eff;
      }
      &:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -40px;
        width: 1px;
        height: 55px;
        background: #409eff;
      }
    }
  }
  .valuation-field-btn {
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -30px;
    &:after {
      content: "";
      position: absolute;
      top: 22px;
      left: 40px;
      width: 50px;
      height: 1px;
      background: #409eff;
    }
  }
}

.valuation-field-list .valuation-field-child:last-child::after {
  content: "";
  position: absolute;
  top: 20px;
  right: 20px;
  width: 1px;
  height: 55px;
  background: rgba($color: #409eff, $alpha: 0);
}

.inputParams-wrap {
  margin-bottom: 20px;
  .valuation-field-wrap {
    .valuation-field-list {
      .valuation-field-child {
        &:before {
          background: none !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerManagement/singleRule.vue